module.exports = __webpack_public_path__ + "toGroom-we-b-n.36654de8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-b-n.jpg
// module id = /Zvu
// module chunks = 0